export default {
  'Adcombo':{
    img:{
      src: 'adcombo.svg',
    }
  },
  'Advidi':{
    img:{
      src: 'advidi.svg',
    }
  },
  'Admitad':{
    img:{
      src: 'admitad.png',
    }
  },
  'AdWork Media':{
    img:{
      src: 'adwork-media.png',
    }
  },
  'Affiliaxe':{
    img:{
      src: 'affiliaxe.png',
    }
  },
  'Aragorn Advertising':{
    img:{
      src: 'admitad.png',
    }
  },
  'Big Bang Ads':{
    img:{
      src: 'big-bang-ads.png',
    }
  },
  'ClickBank':{
    img:{
      src: 'clickbank.png',
    }
  },
  'ClickDealer':{
    img:{
      src: 'clickdealer.png',
    }
  },
  'CrakRevenue':{
    img:{
      src: 'crakrevenue.svg',
    }
  },
  'Cpamatica':{
    img:{
      src: 'cpamatica.png',
    }
  },
  'Gotzha':{
    img:{
      src: 'gotzha.svg',
    }
  },
  'IMonetizeit':{
    img:{
      src: 'imonetizeit.png',
    }
  },
  'lemonads':{
    img:{
      src: 'lemonads.png',
    }
  },
  'Leadbit':{
    img:{
      src: 'leadbit.svg',
    }
  },
  'LosPollos':{
    img:{
      src: 'lospollos.png',
    }
  },
  'M4TRIX NETWORK':{
    img:{
      src: 'm4trix.png',
    }
  },
  'MaxBounty':{
    img:{
      src: 'maxbounty.jpg',
    }
  },
  'Mobidea':{
    img:{
      src: 'mobidea.svg',
    }
  },
  'MOBIPIUM':{
    img:{
      src: 'mobipium.jpg',
    }
  },
  'Monetizer':{
    img:{
      src: 'monetizer.png',
    }
  },
  'MyLead':{
    img:{
      src: 'mylead.png',
    }
  },
  'OFFERRUM':{
    img:{
      src: 'offerrum.svg',
    }
  },
  'Everad':{
    img:{
      src: 'everad.png',
    }
  },
  'Golden Goose':{
    img:{
      src: 'golden-goose2.png',
    }
  },
  'Toro Advertising':{
    img:{
      src: 'toro-advertising.png',
    }
  },
  'Traffic Company':{
    img:{
      src: 'traffic-company.svg',
    }
  },
  'YTZ International':{
    img:{
      src: 'ytz-2.png',
    }
  },
  'Zeydoo':{
    img:{
      src: 'zeydoo.png',
    }
  }
} as {[type: string]: {
    img:{
      src: string
    }
  }}
